<template>
  <svg :width="`${acrylicWidth}in`" :height="`${acrylicHeight}in`" xmlns="http://www.w3.org/2000/svg" :x="x" :y="y">
    <rect v-if="!isClearFloated" x="0" y="0" :width="acrylicWidth" :height="acrylicHeight" fill="none" stroke="none"/>
    <image v-else :href="clearFloatOverlayUrl" :width="acrylicWidth" :height="acrylicHeight" preserveAspectRatio="none"/>
  </svg>
</template>

<script>
import { isEmpty } from "lodash";

export default {
  props: {
    frameSpec: {
      type: Object,
      required: true
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    }
  },
  computed: {
    artwork() {
      return this.frameSpec.getArtwork() || {};
    },
    elevatedMount() {
      return this.frameSpec.mount.elevated;
    },
    mat() {
      return this.frameSpec.mats[0] || {};
    },
    totalsOfAllMatRevealsOrMountReveals() {
      if (!isEmpty(this.mat)) {
        return {
          topInInches: this.frameSpec.mats.reduce((acc, mat) => acc + (mat.reveal && mat.reveal.topInInches), 0),
          rightInInches: this.frameSpec.mats.reduce((acc, mat) => acc + (mat.reveal && mat.reveal.rightInInches), 0),
          bottomInInches: this.frameSpec.mats.reduce((acc, mat) => acc + (mat.reveal && mat.reveal.bottomInInches), 0),
          leftInInches: this.frameSpec.mats.reduce((acc, mat) => acc + (mat.reveal && mat.reveal.leftInInches), 0)
        };
      } else if (this.frameSpec.isFloated() || this.frameSpec.isClearFloated()) {
        return this.frameSpec.mount.reveal;
      } else {
        return {
          topInInches: 0,
          rightInInches: 0,
          bottomInInches: 0,
          leftInInches: 0
        };
      }
    },
    acrylicWidth() {
      if (!this.artwork.exterior) return 0;
      return this.artwork.exterior.artworkOpeningWidthInInches + this.totalsOfAllMatRevealsOrMountReveals.leftInInches + this.totalsOfAllMatRevealsOrMountReveals.rightInInches;
    },
    acrylicHeight() {
      if (!this.artwork.exterior) return 0;
      return this.artwork.exterior.artworkOpeningHeightInInches + this.totalsOfAllMatRevealsOrMountReveals.topInInches + this.totalsOfAllMatRevealsOrMountReveals.bottomInInches;
    },
    isClearFloated() {
      return this.frameSpec.isClearFloated();
    },
    clearFloatOverlayUrl() {
      return "https://cdn.framebridge.com/production/page_addition_assets/421/assets/original/clear-float-overlay-042524.png";
    }
  }
};
</script>

<style scoped>
/* No styles needed */
</style>
